

<div id="mainLoader" class="mainLoader" *ngIf="showLoader">
  <div class="loader-parent">
    <div class="line" [ngClass]="{ k12: productTitle == 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle == 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle == 'K12 Insight' }"></div>
    <div class="line k12" *ngIf="productTitle == 'K12 Insight'"></div>
  </div>
</div>

<form id="surveyFrom" name="form" #f="ngForm" (keydown.enter)="preventEvent($event)"
   autocomplete="off" novalidate>
  <div class="bg-overlay"></div>
  <div >
    <div *ngIf="editResponseData?.responseSrNo" aria-label="Edit Response Title" role="navigation" class="navigation-band top-nav-bar">
      <div class="top-nav-bar-div">
      <span  _ngcontent-ng-c1238830161="" class="edit-response-title">
        {{ getEditResponseTitle()  }}
      </span>
      </div>
      <span _ngcontent-ng-c1238830161="" class="close-edit-modal" (click)="closeModel()"></span>
    </div>
    <div class="surveyWidth survey-border">
      <div class="questions-wrapper" id="questionWrapper" role="main">

        <div *ngIf="isMandatory" class="mndtry-txt-clr">
          <span class="icon__mandatory" aria-label="Mandatory field"></span>
          <span aria-live="polite" role="alert"> {{' ' +editResponseData?.SurveyMessages.requiredInfo }}</span>
        </div>
        <div class="mndtry-txt-clr" *ngIf="isPostPopulate">
          <span aria-live="polite" role="alert">Note: Questions marked with 
            <span class="imgPostPrepop">
      </span> can be Post-populated</span>
        </div>
            <div class="main-ques-cont" *ngFor="
                let questions of editResponseData?.Questions;
                let j = index;
                trackBy: trackByUniqueNumber
              " (keyup.tab)="focusOnQuestion($event.target)" (keyup.shift.tab)="focusOnQuestion($event.target)">
              <div id="dv_main_{{ questions?.UniqueNumber }}" [ngClass]="{
                'divScroll': (questions.qtype != 'RK' &&
                              questions.qtype != 'T' &&
                              (questions.qsubtype != 1 &&
                               questions.qsubtype != 2 &&
                               questions.qsubtype != 3 &&
                               questions.qsubtype != 4)) ||
                            (questions.qtype == 'T' &&
                             [71, 0, 21, 31, 41, 22, 61, 51, 11, 12, 10].includes(questions.qsubtype) &&
                             questions.qtype != 'RW' &&
                             questions.qsubtype != 3),
            
                'disabled-question': isPostEditDisable(j)
              }">

                <div *ngIf="
                    f.submitted &&
                    ((questions.mandatory &&
                      questions.group_no == 0 &&
                      (questions.AnswerText == null ||
                        ((questions.qtype == 'R' ||
                          questions.qtype == 'C' ||
                          questions.qtype == 'L' ||
                          questions.qtype == 'ML' ||
                          questions.qtype == 'HR') &&
                          questions.isOtherAnswer &&
                          questions.otherAnswer == null)) &&
                      questions.qtype != 'CM') ||
                      (questions.isMultiControlValid && !questions.isMultiQuestion) ||
                      (questions.AnswerText == null &&
                        questions.mandatory &&
                        !questions.IsDisabled &&
                        questions.group_no > 0 &&
                        !questions.isMultiQuestion &&
                        questions.isMatrixQuestion)) &&
                    !isCapchaManditorySkip
                  " class="mndtry-txt-clr">
                  <div [innerHTML]="editResponseData?.SurveyMessages.AsteriskMandatory | headerFooterHtml"></div>
                </div>
                <div class="first-div" style="height: 1px; width: 1px; opacity: 0" [hidden]="j != 0"></div>
                <app-question-spacer id="dv_spacer_{{ questions?.UniqueNumber }}" *ngIf="
                    !questions.isMultiQuestion
                  " [BottomPosition]="false" [questionSpacer]="questionSpacerHeight" class="top-question-spacer"
                  #topquestionspacer></app-question-spacer>
                <!-- Matrix Grid --><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    (questions.qtype == 'GR' ||
                      questions.qtype == 'SR' ||
                      questions.qtype == 'GC' ||
                      (questions.qtype == 'T' && !GetIsMulti(GetGroupData(questions.group_no))) ||
                      questions.qtype == 'GD' ||
                      questions.qtype == 'RG' ||
                      questions.qtype == 'RW' ||
                      questions.qtype == 'SC') &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    questions.isMatrixQuestion
                  " class="question-data" [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  ">
                  <app-matrix-grid [JsonData]="GetMatrixGridQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront"
                    [groups]="questions | getgroupedit | getmatrixedit | getmatrixgroupedit"
                    [matrix]="questions | getgroupedit | getmatrixedit" [isSubmitted]="isSubmittedForm" [isMobile]="isMobile"
                    [DropDown]="editResponseData?.SurveyMessages.DropDown"
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-matrix-grid>
                 
                </div>

                <!-- demographics --><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.DemographicFieldID != 0 && !questions.isMultiQuestion" class="question-data"
                  [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  ">
                  <app-demographics [JsonData]="GetMultiQuestionsString(questions)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno" [isMobile]="isMobile"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroupedit" [MonthArray]="editResponseData?.SurveyMessages.strMonthArray"
                    [DropDown]="editResponseData?.SurveyMessages.DropDown" 
                    [isResponseUpdate]="responseQuestions.length > 0 ? false : true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)">
                  </app-demographics>
                 
                </div>

                <!-- Multiple Text Box -->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    questions.qtype == 'T' &&
                    GetIsMulti(GetGroupData(questions.group_no)) &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0
                  " class="question-data" [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          questions.qsubtype == 72 &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-multiple-text-box [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront"
                    [isSubmitted]="isSubmittedForm" [isMobile]="isMobile" 
                    [group]="questions | getgroupedit" (ChangeAnswersData)="UpdateQuestionsData($event)"
                    [matrix]="questions | getgroupedit | getmatrixedit"
                    [isSignatureControl]="questions.qsubtype == 72 ? true : false">
                  </app-multiple-text-box>                  
                </div>

                <!-- Multiple Drop Down--><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    questions.qtype == 'RW' &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    questions.qsubtype != 3 &&
                    questions.qsubtype != 1 &&
                    !questions.isMatrixQuestion
                  " class="question-data" [ngClass]="
                    f.submitted &&
                    questions.isMultiControlValid &&
                    GetIsMulti(GetGroupData(questions.group_no)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  ">
                  <app-multiple-drop-down [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno" [isMobile]="isMobile"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroupedit" [isMDD]="questions | getgroupedit | ismultiedit"
                    [matrix]="questions | getgroupedit | getmatrixedit" [isSubmitted]="isSubmittedForm"
                    [DropDown]="editResponseData?.SurveyMessages.DropDown" 
                    [productTitle]="productTitle" (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-multiple-drop-down>
                 
                </div>

                <!-- drill Down--><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    questions.qtype == 'RW' &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    questions.qsubtype == 3 &&
                    !questions.isMatrixQuestion
                  " class="question-data" [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  ">
                  <app-drill-down [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno" [isMobile]="isMobile"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroupedit" [matrix]="questions | getgroupedit | getmatrixedit"
                    [DropDown]="editResponseData?.SurveyMessages.DropDown" 
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-drill-down>
                 
                </div>

                <!-- Grid Questions--><!-- questions.isCQ && questions.isCQHide && questions.isGroupRule-->
                <div  id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    (questions.qtype == 'GR' ||
                      questions.qtype == 'SR' ||
                      questions.qtype == 'GC' ||
                      questions.qtype == 'SC' ||
                      questions.qtype == 'RG' ||
                      (questions.qtype == 'RW' && questions.qsubtype == 1)) &&
                    questions.group_no > 0 &&
                    !questions.isMultiQuestion &&
                    questions.DemographicFieldID == 0 &&
                    !questions.isMatrixQuestion
                  " class="question-data" [ngClass]="
                    f.submitted &&
                    !isMobile &&
                    (questions.qtype == 'SR' || questions.qtype == 'SC') &&
                    questions.isMultiControlValid &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : ''
                  ">
                  <app-grid-questions [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront"
                    [group]="questions | getgroupedit" [isSubmitted]="isSubmittedForm"
                    [matrix]="questions | getgroupedit | getmatrixedit" [isMobile]="isMobile"
                     (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-grid-questions>
                  
                </div>

                <!-- Symbol rating scale -->
                <div id="dv_{{ questions?.UniqueNumber }}" [hidden]="
                    questions.isCQ &&
                    ((questions.isGroupCQHide && questions.isNOGroupRule) ||
                      (questions.isGroupRule && questions.isCQHide))
                  " id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'GQ' && !questions.isMultiQuestion" class="question-data" [ngClass]="
                    f.submitted && questions.isMultiControlValid && !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-symbol-rating-scale [JsonData]="GetMultiQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno" [isDisplaySubQno]="false"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                     [group]="questions | getgroupedit"
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-symbol-rating-scale>
                  
                </div>

                <!-- Radio Button -->
                <div *ngIf="
                    ((!questions.isCQHide && questions.qtype == 'R' && questions.qsubtype != 2) ||
                      questions.qtype == 'HR' ||
                      (questions.qtype == 'RT' && questions.qsubtype == 7))
                  " class="question-data" [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerText == null ||
                      (questions.isOtherAnswer && questions.otherAnswer == null)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : (f.submitted &&
                            questions.isSoftRequired &&
                            questions.AnswerText == null &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip) ||
                          (f.submitted &&
                            questions.isSQ &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip &&
                            CheckInlineQuestion(questions, pageNumber))
                        ? 'soft-req'
                        : ''
                  ">
                  <app-radio-button [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                   (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)">
                  </app-radio-button>

                </div>

                <!-- Thumbs Up -->
                <div id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'R' && questions.qsubtype == 2" class="question-data" [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-thumbs-up [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                   (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)">
                  </app-thumbs-up>
                 
                </div>

                <!-- Check Box -->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    ((!questions.isCQHide && questions.qtype == 'C') ||
                      questions.qtype == 'ML')
                  " class="question-data" [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerText == null ||
                      (questions.isOtherAnswer && questions.otherAnswer == null)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : (f.submitted &&
                            questions.isSoftRequired &&
                            questions.AnswerText == null &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip) ||
                          (f.submitted &&
                            questions.isSQ &&
                            nextButtonClickNo <= 1 &&
                            !isCapchaManditorySkip &&
                            CheckInlineQuestion(questions, pageNumber))
                        ? 'soft-req'
                        : ''
                  ">
                  <app-check-box [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)">
                  </app-check-box>
                  
                </div>

                <!-- Text Box -->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="questions.qtype == 'T' && questions.group_no == 0"
                  class="question-data" [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.AnswerText == null &&
                          questions.isSoftRequired &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-text-box [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno" [isDisplaySubQno]="false"
                    [MonthArray]="editResponseData?.SurveyMessages.strMonthArray"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                    [isMTB]="false" [isDemographics]="false"
                    (ChangeAnswersData)="UpdateQuestionsData($event)"
                    (ChangeLoadingAnswersData)="UpdateLoadingQuestionsData($event)">
                  </app-text-box>
                  
                </div>

                <!-- Ranking -->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    !questions.isCQHide &&
                    questions.qtype == 'RK'
                  " class="question-data" [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerText == null ||
                      (questions.AnswerText != null &&
                        questions.selectedOptionList.length == 0)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-ranking [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                    [Rank]="editResponseData?.SurveyMessages.Rank"
                    [isResponseUpdate]="responseQuestions.length > 0 ? false : true" 
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-ranking>
                  
                </div>

                <!-- Drop Down -->
                <div id="dv_{{ questions?.UniqueNumber }}" class="question-data" *ngIf="
                    (questions.qtype == 'L' ||
                      (questions.qtype == 'RT' && questions.qsubtype == 0)) &&
                    questions.group_no == 0 &&
                    !(
                      (questions.isCQ && questions.isCQHide) ||
                      (questions.isSQ && questions.isCQHide)
                    )
                  " [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    (questions.AnswerID == 0 ||
                      questions.AnswerID == null ||
                      (questions.isOtherAnswer && questions.otherAnswer == null)) &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-drop-down [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isDisplaySubQno]="false"
                    [isMDD]="false" [isNonSearchable]="false" [DropDown]="editResponseData?.SurveyMessages.DropDown"
                    [isMobile]="isMobile" 
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-drop-down>
                  
                </div>

                <!-- Rating Scale -->
                <div id="dv_{{ questions?.UniqueNumber }}"
                  *ngIf="questions.qtype == 'RS' && !(questions.isCQ && questions.isCQHide)" class="question-data"
                  [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-rating-scale [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                   (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-rating-scale>
                 
                </div>

                <!-- Numeric Allocation -->
                <div id="dv_{{ questions?.UniqueNumber }}" *ngIf="
                    !questions.isCQHide &&
                    questions.qtype == 'CS' 
                  " class="question-data" [ngClass]="
                    f.submitted &&
                    questions.mandatory &&
                    questions.AnswerText == null &&
                    !isCapchaManditorySkip
                      ? 'mandatory'
                      : f.submitted &&
                          questions.isSoftRequired &&
                          questions.AnswerText == null &&
                          nextButtonClickNo <= 1 &&
                          !isCapchaManditorySkip
                        ? 'soft-req'
                        : ''
                  ">
                  <app-numeric-allocation [JsonData]="GetQuestionsString(questions, pageNumber)"
                    [isDisplayQno]="editResponseData?.SurveySettings.DisplayQno"
                    [isMandatoryUpfront]="editResponseData?.SurveySettings.isMandatoryUpfront" [isMobile]="isMobile"
                    [isResponseUpdate]="responseQuestions.length > 0 ? false : true"
                    (ChangeAnswersData)="UpdateQuestionsData($event)">
                  </app-numeric-allocation>

                </div>
              </div>

              <!-- Question Spacer handled here -->
              <app-question-spacer *ngIf="
                  !questions.isMultiQuestion
                " [BottomPosition]="true" [questionSpacer]="questionSpacerHeight">
              </app-question-spacer>

             
            </div>


      </div>
    </div>

    <div  role="navigation" aria-label="Navigation Band" class="navigation-band" [ngStyle]="{ 'display': showFooter ? 'block' : 'none' }">
        
      <div  
        class="tblPageFooter footerBtnSyled" #targetElement>

        <div class="navigation-btns-wrapper btn-align-mar submit-btn-wrap">
          <button type="button" (click)="closeModel()" class="cancel-button">
            <!-- Cancel -->
            <span>Cancel</span>
          </button>
        </div>
        <div  class="navigation-btns-wrapper btn-align-mar">
          <button type="submit" (click)="SubmitData('SUB')" class="submit-button" >
            <!-- Submit -->
            <span class="footer-btn-text">Submit</span>
          </button>
        </div>

        <div *ngIf="editResponseData.isComplete == false" (click)="SubmitData('SAC')" class="navigation-btns-wrapper btn-align-mar submit-btn-wrap">
          <button type="submit" class="submit-button">
            <!-- Save and Continue -->
            <span>Save and Continue</span>
          </button>
        </div>

      </div>
    </div>

    <div  class="footer-spacer"></div>
  </div>
  <!-- Added saveandcontinue-aligncenter for PRT 102492 -->
</form>
